import { getLanguageByCode } from '@helpers/languages';
import { httpPost } from './apiService';
import { SlugEntityAdminApiService } from './slugEntityAdminApiService';
import { ArticleEntity } from '@models/article';
import { FeatureCardSelectItem } from '@models/section/featureCardSection';

export abstract class ArticleEntityAdminService<
    Entity extends ArticleEntity
> extends SlugEntityAdminApiService<Entity> {
    constructor(baseUrl: string) {
        super(baseUrl);
    }

    public async duplicate(article: Entity, id: number): Promise<number | undefined> {
        const response = await httpPost(`${this.baseUrl}/duplicate/${id}`, JSON.stringify(article));

        return this.returnResult<number>(await response.json());
    }

    public getFeaturedCardSelectItems = async (languageCode: string): Promise<FeatureCardSelectItem[]> => {
        const languageId = getLanguageByCode(languageCode)?.id || 1;
        return (await this.getAll(languageId)).map((article) => ({
            content: article.title,
            value: article.id,
        }));
    };
}
